import React from 'react';
import DecryptText from './DecryptText';
import DecryptASCII from './DecryptASCII';
import HackAnimation from './HackAnimation';
import WelcomeHero from './WelcomeHero';
import WhoamiBanner from './WhoamiBanner';

/**
 * Renders a single output item based on its type
 */
const TerminalOutput = ({ item, index }) => {
  switch (item.type) {
    case 'ascii':
      return (
        <div key={index} className="ascii-art">
          {item.content}
        </div>
      );
      
    case 'decrypt-ascii':
      return (
        <div key={index}>
          <DecryptASCII text={item.content} speed={20} />
        </div>
      );
      
    case 'decrypt':
      return (
        <div key={index} className="terminal-line">
          <span className="terminal-result">
            <DecryptText text={item.content} delay={item.delay || 0} speed={30} />
          </span>
        </div>
      );
      
    case 'command':
      return (
        <div key={index} className="terminal-line">
          <span className="terminal-prompt">
            guest@c4sh3r-portfolio:~<span className="prompt-sigil">$</span>
          </span>
          <span className="terminal-command">{item.content}</span>
        </div>
      );
      
    case 'password':
      return (
        <div key={index} className="terminal-line">
          <span className="terminal-result" style={{ color: 'var(--text-secondary)' }}>{item.content}</span>
        </div>
      );
      
    case 'error':
      return (
        <div key={index} className="terminal-line">
          <span className="terminal-result" style={{ color: '#ff5f57' }}>{item.content}</span>
        </div>
      );
      
    case 'success':
      return (
        <div key={index} className="terminal-line">
          <span className="terminal-result" style={{ color: '#28ca42' }}>{item.content}</span>
        </div>
      );
      
    case 'hack':
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result typing-text" style={{ color: '#ff5f57', whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{item.content}</pre>
        </div>
      );
      
    case 'hack-epic':
      return (
        <div key={index}>
          <HackAnimation target={item.target} />
        </div>
      );
      
    case 'quote':
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result" style={{ color: '#ffd700', whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontStyle: 'italic' }}>{item.content}</pre>
        </div>
      );
      
    case 'stats':
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result" style={{ color: 'var(--steel)', whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '14px' }}>{item.content}</pre>
        </div>
      );
      
    case 'web3':
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result" style={{ color: 'var(--steel)', whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '14px' }}>{item.content}</pre>
        </div>
      );
      
    case 'web3-scan':
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result" style={{ color: item.severity || 'var(--steel)', whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '13px', lineHeight: '1.5' }}>{item.content}</pre>
        </div>
      );
      
    case 'whoami-banner':
      return <div key={index}><WhoamiBanner /></div>;

    case 'hero':
      return (
        <div key={index}>
          <WelcomeHero
            logoSrc={item.logoSrc}
            tagline={item.tagline}
          />
        </div>
      );

    case 'logo':
      return (
        <div key={index} style={{ display: 'flex', justifyContent: 'center', margin: '15px 0' }}>
          <img
            src={item.src}
            alt={item.alt || 'logo'}
            data-testid="terminal-welcome-logo"
            style={{
              width: '140px',
              height: '140px',
              borderRadius: '12px',
              border: '1px solid var(--steel-line-strong)',
              boxShadow: '0 0 30px rgba(176, 107, 255, 0.14)',
              objectFit: 'cover',
              animation: 'logo-fade-in 1.2s ease-out'
            }}
          />
        </div>
      );
      
    default:
      return (
        <div key={index} className="terminal-line">
          <pre className="terminal-result" style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{item.content}</pre>
        </div>
      );
  }
};

export default TerminalOutput;
